var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-modal',{attrs:{"show":_vm.show,"isTableModal":true},on:{"update:show":function($event){return _vm.$emit('update:show', $event)}}},[_c('h4',{staticClass:"title title-up",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    Rundmail Einstellungen (ID: "+_vm._s(_vm.id)+")\n  ")]),_vm._v(" "),_c('resource',{attrs:{"resource":"circularMail","original":_vm.circularMail,"static-mode":true,"attributes":[
      {
        name: 'sender_info|name',
        label: 'Absender',
        type: 'StaticText'
      },
      {
        name: 'circular_mail_messages',
        label: 'Nachrichtenelemente',
        type: 'MessageElementsSelector'
      },
      {
        name: 'send_at',
        label: 'Versenden am',
        type: 'DateTimeSelector',
        value: null
      },

      {
        name: 'age',
        label: 'Alter',
        type: 'MultiSliderSelector',
        max: 125,
        min: 18,
        isFilter: true
      },
      {
        name: 'send_to_gender',
        label: 'Geschlecht',
        type: 'SexSelector',
        multiSelect: true,
        isFilter: true
      },
      {
        name: 'photo',
        label: 'Foto',
        type: 'OptionSelector',
        isFilter: true
      },
      {
        name: 'registered_from',
        label: 'Registriert von',
        type: 'DateSelector',
        isFilter: true
      },
      {
        name: 'registered_to',
        label: 'Registriert bis',
        type: 'DateSelector',
        isFilter: true
      },
      {
        name: 'max_days_offline',
        label: 'Tage letzter Login',
        type: 'UserActivitySelector',
        max: _vm.circularmailOfflineDays,
        min: 0,
        isFilter: true
      },
      {
        name: 'transaction',
        label: 'Käufe',
        type: 'OptionSelector',
        isFilter: true
      },
      {
        name: 'spent',
        label: _vm.spendLabel,
        type: 'number',
        isFilter: true
      }
    ]}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }